/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
    IonContent,
    IonGrid,
    IonPage,
    IonRow,
    IonCol,
    IonLoading,
} from "@ionic/react";
import { useParams } from "react-router";
import { useAuth } from "../../context/Auth";
import { getEmailContactUnsubscribe } from "../../services/GlobalServices";
import logo from "../../assets/images/logo.svg";

const MarketingUnsubscribePage: React.FC = () => {
    const { uuid } = useParams<{ uuid: string }>();
    const { checkAxiosError } = useAuth();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<boolean>(false);

    useEffect(() => {
        if (!uuid) {
            setError("Hiányzó azonosító (uuid).");
            return;
        }
        setLoading(true);
        setError(null);
        setSuccess(false);
        getEmailContactUnsubscribe(uuid)
            .then((_res: any) => {
                setSuccess(true);
            })
            .catch((err: any) => {
                checkAxiosError(err);
                const message =
                    err?.response?.data?.message ??
                    err?.message ??
                    "Ismeretlen hiba";
                setError(message);
            })
            .finally(() => setLoading(false));
    }, [uuid]);

    return (
        <IonPage>
            <IonContent>
                <IonGrid className="ion-padding" fixed>
                    <IonRow>
                        <IonCol size="12" className="ion-col-center-content">
                            <img
                                src={logo}
                                alt="myPatent Logo"
                                className="desktopLogo"
                            />
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol
                            size="12"
                            style={{ textAlign: "center", paddingTop: "20px" }}
                        >
                            {success && (
                                <h1>
                                    A leiratkozás sikerült.
                                    <br />
                                    Bezárhatja az oldalt.
                                </h1>
                            )}
                            {!success && !error && (
                                <h1>Leiratkozás feldolgozása...</h1>
                            )}
                            {error && (
                                <div>
                                    <h1>Hiba történt a leiratkozás közben</h1>
                                    <div
                                        style={{ marginTop: 8, color: "#c00" }}
                                    >
                                        {error}
                                    </div>
                                </div>
                            )}
                        </IonCol>
                    </IonRow>
                </IonGrid>
                <IonLoading isOpen={loading} message={"Kérem várjon..."} />
            </IonContent>
        </IonPage>
    );
};

export default MarketingUnsubscribePage;
